import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FirebaseService } from '../auth/firebase.service';
import { environment } from '../../../environments/environment';
import { Worker } from '../../models/Worker';

@Injectable({
  providedIn: 'root'
})
export class WorkerService {

  constructor(private http: HttpClient, private firebaseService: FirebaseService){}

  getWorkers(){
    return this.http.get<Worker[]>(`${environment.URL_API}/api/workers`, {headers: this.firebaseService.authHeader})
  }
}
